<!--订单详情页-->
<template>
    <div>
        <v-app-bar
            app
            :style="{
                backgroundImage: navigationMode == 'horizontal' ? 'white' : theme.topBarBgColor,
                borderBottom: '#bfbfbf 2px solid',
                color: theme.pageFontColor,
                backgroundColor: navigationMode == 'horizontal' ? theme.topBarBgColor : 'white',
            }"
            :color="theme.topBarBgColor"
            height="45vh"
            flat
            :class="navigationMode == 'horizontal' ? 'mt-15' : ''"
        >
            <el-page-header @back="back" content="订单详情"></el-page-header>
        </v-app-bar>
        <v-container fluid class="mt-n3">
            <v-row>
                <v-col cols="12" md="12">
                    <v-card outlined class="pa-4" height="100%" :color="theme.elementBgColor">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane name="first">
                                <span
                                    slot="label"
                                    :style="{
                                        color:
                                            activeName == 'first' ? '#4dabf7' : theme.pageFontColor,
                                    }"
                                >
                                    充电曲线
                                </span>
                                <v-card
                                    flat
                                    outlined
                                    class="pa-4"
                                    :color="theme.pageBgColor"
                                    width="200vh"
                                    height="70vh"
                                >
                                    <order-echarts />
                                </v-card>
                            </el-tab-pane>
                            <el-tab-pane name="second">
                                <span
                                    slot="label"
                                    :style="{
                                        color:
                                            activeName == 'second'
                                                ? '#4dabf7'
                                                : theme.pageFontColor,
                                    }"
                                >
                                    订单信息
                                </span>
                                <v-card
                                    outlined
                                    flat
                                    :color="theme.pageBgColor"
                                    class="mt-3 pt-4 pb-4"
                                >
                                    <el-steps
                                        :active="activeStauts"
                                        align-center
                                        :process-status="newStaus"
                                        finish-status="success"
                                    >
                                        <el-step
                                            v-for="(item, index) in orderStatus"
                                            :key="index"
                                            :title="item.content"
                                            :icon="item.icon"
                                            :description="item.timestamp"
                                        ></el-step>
                                    </el-steps>
                                </v-card>
                                <v-card outlined flat :color="theme.pageBgColor" class="mt-3 pa-2">
                                    <v-row>
                                        <v-col
                                            cols="2"
                                            md="2"
                                            v-for="(item, index) in items"
                                            :key="'item' + index"
                                            v-if="orderData.status != 1"
                                        >
                                            <div
                                                :style="{
                                                    backgroundColor: theme.elementBgColor,
                                                    border: 'none',
                                                    height: '5vw',
                                                    width: '12.7vw',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: '0.5vw',
                                                }"
                                            >
                                                <div
                                                    class="top"
                                                    :style="{
                                                        color: theme.pageFontColor,
                                                    }"
                                                >
                                                    <div
                                                        style="
                                                            height: 100%;
                                                            width: 80%;
                                                            border-bottom: 1px solid #e9ecef;
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            font-size: 0.8vw"
                                                    >
                                                        {{ item.label }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="bottom"
                                                    :style="{
                                                        fontSize: '1.1vw',
                                                        color: theme.pageFontColor,
                                                    }"
                                                >
                                                    {{ item.numerical }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col
                                            cols="2"
                                            md="2"
                                            v-for="(item, index) in orderDetails"
                                            :key="'orderDetails' + index"
                                            v-if="orderData.status == 1"
                                        >
                                            <div
                                                :style="{
                                                    backgroundColor: theme.elementBgColor,
                                                    border: 'none',
                                                    height: '5vw',
                                                    width: '12.7vw',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: '0.5vw',
                                                }"
                                            >
                                                <div
                                                    class="top"
                                                    :style="{
                                                        color: theme.pageFontColor,
                                                    }"
                                                >
                                                    <div
                                                        style="
                                                            height: 100%;
                                                            width: 80%;
                                                            border-bottom: 1px solid #e9ecef;
                                                            display: flex;
                                                            align-items: center;
                                                            justify-content: center;
                                                            font-size: 0.8vw"
                                                    >
                                                        {{ item.label }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="bottom"
                                                    :style="{
                                                        fontSize: '1.1vw',
                                                        color: theme.pageFontColor,
                                                    }"
                                                >
                                                    {{ item.numerical }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            v-for="(order, index1) in orderInfo"
                                            :key="'order' + index1"
                                        >
                                            <el-form
                                                label-position="right"
                                                label-width="150px"
                                                class="mt-3"
                                            >
                                                <el-form-item
                                                    class="mt-n4"
                                                    v-for="(item, index2) in order"
                                                    :key="index2"
                                                    :label="item.title"
                                                    :style="{
                                                        backgroundColor: theme.elementBgColor,
                                                        color: theme.pageFontColor,
                                                    }"
                                                >
                                                    {{ item.info }}
                                                </el-form-item>
                                            </el-form>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </el-tab-pane>
                        </el-tabs>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import util from "@/util";
import OrderEcharts from "@/components/Echarts/OrderEcharts";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "Details",
    data() {
        return {
            activeName: "first",
            newStaus: "success", //当前步骤的状态
            activeStauts: 1, //当前的状态步骤
            orderStatus: [],
            orderDetails: [
                {
                    label: "功率",
                    key: "TotalPower",
                    numerical: "",
                },
                {
                    label: "电量",
                    key: "Soc",
                    numerical: "",
                },
                {
                    label: "电压",
                    key: "VoltageA",
                    numerical: "",
                },
                {
                    label: "电流",
                    key: "CurrentA",
                    numerical: "",
                },
            ],
            items: [
                {
                    label: "充电电量(KW-h)",
                    key: "total_power",
                    numerical: "",
                },
                {
                    key: "time",
                    label: "充电时长",
                    numerical: "",
                },
                {
                    key: "elec_money",
                    label: "电费(元)",
                    numerical: "",
                },
                {
                    key: "sevice_money",
                    label: "服务费(元)",
                    numerical: "",
                },
                {
                    key: "money",
                    label: "收款金额(元)",
                    numerical: "",
                },
                {
                    label: "退款金额(元)",
                    numerical: "",
                },
            ],
            //订单信息
            orderInfo: [
                [
                    {
                        key: "no",
                        title: "充电订单编号：",
                        info: "",
                    },
                    {
                        key: "createtime",
                        title: "充电开始时间：",
                        info: "",
                    },
                    {
                        key: "updatetime",
                        title: "充电结束时间：",
                        info: "",
                    },
                    {
                        key: "status",
                        title: "订单状态：",
                        info: "",
                    },
                    {
                        key: "tk_user_id",
                        title: "用户ID：",
                        info: "",
                    },
                    {
                        key: "mobile",
                        title: "手机号：",
                        info: "",
                    },
                ],
                [
                    {
                        key: "station_name",
                        title: "站点名称：",
                        info: "",
                    },
                    {
                        key: "connector_id",
                        title: "枪编码：",
                        info: "",
                    },
                    {
                        key: "start_soc",
                        title: "开始电量（%）：",
                        info: "",
                    },
                    {
                        key: "end_soc",
                        title: "结束电量（%）：",
                        info: "",
                    },
                    {
                        key: "refund",
                        title: "退款交易号：",
                        info: "",
                    },
                    {
                        key: "cec_id",
                        title: "互联互通：",
                        info: "",
                    },
                    {
                        key: "track",
                        title: "未知参数track：",
                        info: "",
                    },
                ],
            ],
            no: null,
        };
    },
    components: {
        OrderEcharts,
    },
    watch: {
        orderData: {
            handler(val) {
                this.dealOrder(val);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["orderDetail", "orderData", "contactInfo", "navigationMode", "theme"]),
    },
    created() {
        if (!this.$route.params.no) {
            this.$router.go(-1);
        }
    },
    async mounted() {
        this.no = this.$route.params.no;
        let postData = {
            no: this.no,
        };
        await store.dispatch("getOrderDetail", postData);
        console.log(this.orderDetail);
    },
    methods: {
        handleClick(tab, event) {
            let name = tab.name;
            if (name === "second") {
                this.dealOrder(this.orderData);
            }
        },
        /*返回*/
        back() {
            this.$router.go(-1);
        },
        /*处理订单*/
        dealOrder(data) {
            this.dealStaus(data);
            for (let i = 0; i < this.orderInfo.length; i++) {
                for (let j = 0; j < this.orderInfo[i].length; j++) {
                    Object.keys(data).forEach(key => {
                        if (this.orderInfo[i][j].key == "createtime") {
                            this.orderInfo[i][j].info = this.formatDate(data["createtime"] * 1000);
                        } else if (this.orderInfo[i][j].key == "updatetime") {
                            if (
                                data["status"] === 3 ||
                                data["status"] === 4 ||
                                data["status"] === 5
                            ) {
                                this.orderInfo[i][j].info = this.formatDate(
                                    data["updatetime"] * 1000
                                );
                            } else {
                                this.orderInfo[i][j].title = "更新时间";
                                this.orderInfo[i][j].info = this.formatDate(
                                    data["updatetime"] * 1000
                                );
                            }
                        } else if (this.orderInfo[i][j].key == "status") {
                            this.orderInfo[i][j].info = this.statusText(data["status"]);
                        } else if (this.orderInfo[i][j].key == "cec_id") {
                            this.orderInfo[i][j].info = this.cecText(data["cec_id"]);
                        } else if (key === this.orderInfo[i][j].key) {
                            this.orderInfo[i][j].info = data[key];
                        }
                    });
                }
            }
            for (let i2 = 0; i2 < this.items.length; i2++) {
                Object.keys(data).forEach(key => {
                    if (this.items[i2].key === "total_power" && data["total_power"]) {
                        this.items[i2].numerical = data["total_power"];
                    } else if (this.items[i2].key === "time") {
                        if (
                            this.orderInfo[0][3].info === "完成" ||
                            this.orderInfo[0][3].info === "待支付"
                        ) {
                            this.items[i2].numerical = this.TimeSpan(
                                data["createtime"],
                                data["updatetime"]
                            );
                        }
                    } else if (this.items[i2].key === "money") {
                        if (data["elec_money"] || data["sevice_money"]) {
                            this.items[i2].numerical = this.addNum(
                                data["elec_money"],
                                data["sevice_money"]
                            );
                        }
                    } else {
                        if (this.items[i2].key === key && data[key]) {
                            this.items[i2].numerical = data[key];
                        }
                    }
                });
            }
            if (this.orderData.status == 1) {
                Object.keys(this.orderDetail).forEach(key => {
                    for (let i = 0; i < this.orderDetails.length; i++) {
                        if (this.orderDetails[i].key == key) {
                            this.orderDetails[i].numerical = this.orderDetail[key];
                        }
                    }
                });
            }
        },
        /*处理订单流程*/
        dealStaus(data) {
            if (data["status"] != 2) {
                this.orderStatus = [
                    {
                        id: 0,
                        content: "创建订单",
                        timestamp: this.formatDate(data["createtime"] * 1000),
                        type: "success",
                        icon: "",
                    },
                    {
                        id: 1,
                        content: "充电中",
                        timestamp: "",
                        type: "success",
                        icon: "",
                    },
                    {
                        id: 5,
                        content: "正在生成订单",
                        timestamp: "",
                        type: "success",
                    },
                    {
                        id: 4,
                        content: "待支付",
                        timestamp: "",
                        type: "success",
                    },
                    {
                        id: 3,
                        content: "完成",
                        timestamp: "",
                        type: "success",
                    },
                ];
                for (let i = 0; i < this.orderStatus.length; i++) {
                    if (data["status"] === this.orderStatus[i].id) {
                        this.activeStauts = i;
                        this.orderStatus[i].type = "suceess";
                        this.orderStatus[i].timestamp = this.formatDate(data["updatetime"] * 1000);
                    } else {
                        this.orderStatus[i].type = "info";
                    }
                }
            } else {
                this.orderStatus = [
                    {
                        id: 0,
                        content: "创建订单",
                        timestamp: this.formatDate(data["createtime"] * 1000),
                        type: "success",
                        icon: "el-icon-check",
                    },
                    {
                        id: 1,
                        content: "充电中",
                        timestamp: "",
                        type: "error",
                        icon: "el-icon-check",
                    },
                    {
                        id: 2,
                        content: "启动失败",
                        timestamp: this.formatDate(data["updatetime"] * 1000),
                        type: "error",
                    },
                ];
            }
        },
        /*显示状态*/
        statusText(status) {
            let textArr = [
                {
                    id: 0,
                    value: "启动中",
                },
                {
                    id: 1,
                    value: "充电中",
                },
                {
                    id: 2,
                    value: "启动失败",
                },
                {
                    id: 3,
                    value: "完成",
                },
                {
                    id: 4,
                    value: "待支付",
                },
                {
                    id: 5,
                    value: "正在生成订单",
                },
            ];
            let text = "";
            textArr.forEach((val, index) => {
                if (val.id == status) {
                    text = val.value;
                }
            });
            return text;
        },
        /*显示互联互通*/
        cecText(cec_id) {
            let text = "";
            if (!cec_id) {
                return;
            }
            for (let i = 0; i < this.contactInfo.length; i++) {
                if (cec_id === this.contactInfo[i].id) {
                    text = this.contactInfo[i].name;
                }
            }
            return text;
        },
        /*充电时长时间格式*/
        TimeSpan(createtime, updatetime) {
            if (updatetime == null) {
                return "";
            }
            let time = updatetime - createtime;
            var ret = "";
            let h;
            let m;
            let s;
            if (time >= 3600) {
                h = parseInt(time / 3600);
                ret += h;
                ret += "小时";

                let remaining = time - h * 3600;
                if (remaining >= 60) {
                    m = parseInt((time % 3600) / 60);
                    ret += m;
                    ret += "分钟";
                    s = remaining - m * 60;
                } else {
                    s = remaining;
                }
                ret += s;
                ret += "秒";
            } else if (time < 3600 && time >= 60) {
                m = parseInt((time % 3600) / 60);
                ret += m;
                ret += "分钟";
                s = time - m * 60;
                if (s > 0 && s < 60) {
                    ret += s;
                    ret += "秒";
                }
            } else if (time > 0 && time < 60) {
                s = time;
                ret += s;
                ret += "秒";
            } else {
                ret += "0";
            }
            return ret;
        },
        /*将时间转换为yyyy-mm-dd hh-mmm-ss*/
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + "-";
            var MM =
                (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
                "-";
            var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hh = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
            var mm = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
            var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return YY + MM + DD + " " + hh + mm + ss;
        },
        /*价格相加*/
        addNum(elec, sevice) {
            var r1, r2, m;
            try {
                r1 = elec.toString().split(".")[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = sevice.toString().split(".")[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            let a = Math.round(elec * m + sevice * m) / m;
            return a;
        },
    },
    beforeRouteLeave(to, from, next) {
        store.commit("SET_ORDER_DETAIL", null);
        store.commit("SET_ORDER_INFO", null);
        next();
    },
};
</script>
<style scoped>
.top {
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bottom {
    width: 100%;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
